import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getMstaddresstype = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Mstaddresstype/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMstaddresstype = (payload) => {
  return axios.post(`${URL_ORI}/api/Mstaddresstype`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdMstaddresstype = (id) => {
  return axios
    .get(`${URL_ORI}/api/Mstaddresstype/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMstaddresstype = (payload) => {
  return axios.put(`${URL_ORI}/api/Mstaddresstype`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteMstaddresstype = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Mstaddresstype`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// location master

export const getLocationMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/LocationMaster/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createLocationMaster = (payload) => {
  return axios.post(`${URL_ORI}/api/LocationMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdLocationMaster = (id) => {
  return axios
    .get(`${URL_ORI}/api/LocationMaster/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateLocationMaster = (payload) => {
  return axios.put(`${URL_ORI}/api/LocationMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteLocationMaster = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/LocationMaster`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Country

export const getCountry = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Country/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createCountry = (payload) => {
  return axios.post(`${URL_ORI}/api/Country`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdCountry = (id) => {
  return axios
    .get(`${URL_ORI}/api/Country/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateCountry = (payload) => {
  return axios.put(`${URL_ORI}/api/Country`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteCountry = (payload) => {
  return axios.delete(`${URL_ORI}/api/Country`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
